export const i18n = {
  en: {
    premium: "Phu Quoc Premium Dining",
    all: "All",
    appetizers: "Appetizers",
    salads: "Salads",
    soups: "Soups",
    pho: "Pho Noodles",
    seafood: "Seafood BBQ",
    main: "Main Dishes",
    fish: "Fish Dishes",
    pasta: "Pasta",
    curry: "Curry",
    beverages: "Beverages",
    dessert: "Dessert",
    smoothies: "Smoothies",
    juice: "Fresh Juice",
    cocktails: "Cocktails",
    beer: "Beer",
    wine: "Wine",
    coffee: "Coffee",
    softDrinks: "Soft Drinks",
    breakfast: "Breakfast",
    noodles: "Noodles",
    rice: "Rice Dishes",
    suggestions: "Preparation Suggestions",
    addTray: "Add to Tray",
    empty: "Tray empty",
    home: "Home",
    history: "History",
    chefNote: "Chef's Note",
    notePlaceholder: "Any allergies or special requests?",
    confirmOrder: "Confirm Order",
    orderNow: "ORDER NOW",
    sent: "Sent!",
    successMsg: "Order successful. Kitchen is now preparing your request.",
    backMenu: "Back to Menu",
    noIce: "No Ice",
    lessIce: "Less Ice",
    extraIce: "Extra Ice",
    noSugar: "No Sugar",
    lessSugar: "Less Sugar",
    extraSweet: "Extra Sweet",
    roomTemp: "Room Temp",
    spicy: "Spicy BBQ",
    garlic: "Lemon Garlic",
    plain: "Plain Grilled",
    peel: "Peel for me",
    wellDone: "Well Done",
    rare: "Rare",
    mediumRare: "Medium Rare",
    medium: "Medium",
    trayTitle: "Your Tray",
    almostThere: "Almost there!",
    tableSub: "Select your table number",
    admin: "Admin",
    dashboard: "Dashboard",
    searchPlaceholder: "Search dishes...",
    selectLanguage: "Select Language",
    ingredients: "Ingredients",
    bestChoice: "Best Choice",
    total: "Total",
    items: "items",
    tableNumber: "Table Number",
    emailPlaceholder: "Email (optional)",
    close: "Close",
    cancel: "Cancel",
    continue: "Continue",
    recommended: "You might also like"
  },
  vi: {
    premium: "Ẩm Thực Cao Cấp Phú Quốc",
    all: "Tất cả",
    appetizers: "Khai vị",
    salads: "Salad",
    soups: "Súp",
    pho: "Phở",
    seafood: "Hải sản BBQ",
    main: "Món chính",
    fish: "Món cá",
    pasta: "Mì Ý",
    curry: "Cà ri",
    beverages: "Đồ uống",
    dessert: "Tráng miệng",
    smoothies: "Sinh tố",
    juice: "Nước ép tươi",
    cocktails: "Cocktail",
    beer: "Bia",
    wine: "Rượu vang",
    coffee: "Cà phê",
    softDrinks: "Nước ngọt",
    breakfast: "Bữa sáng",
    noodles: "Mì",
    rice: "Cơm",
    suggestions: "Gợi ý chế biến",
    addTray: "Thêm vào Khay",
    empty: "Khay đang trống",
    home: "Trang chủ",
    history: "Lịch sử",
    chefNote: "Ghi chú cho đầu bếp",
    notePlaceholder: "Dị ứng hoặc yêu cầu đặc biệt?",
    confirmOrder: "Xác nhận",
    orderNow: "GỬI ĐƠN NGAY",
    sent: "Đã gửi!",
    successMsg: "Đặt món thành công.",
    backMenu: "Quay lại menu",
    noIce: "Không đá",
    lessIce: "Ít đá",
    extraIce: "Nhiều đá",
    noSugar: "Không đường",
    lessSugar: "Ít đường",
    extraSweet: "Ngọt hơn",
    roomTemp: "Nhiệt độ phòng",
    spicy: "BBQ cay",
    garlic: "Chanh tỏi",
    plain: "Nướng thuần",
    peel: "Lột vỏ giúp tôi",
    wellDone: "Chín kỹ",
    rare: "Tái",
    mediumRare: "Tái vừa",
    medium: "Vừa",
    trayTitle: "Khay Của Bạn",
    almostThere: "Sắp xong rồi!",
    tableSub: "Vui lòng chọn số bàn",
    admin: "Quản trị",
    dashboard: "Bảng điều khiển",
    searchPlaceholder: "Tìm món...",
    selectLanguage: "Chọn ngôn ngữ",
    ingredients: "Nguyên liệu",
    bestChoice: "Được yêu thích",
    total: "Tổng cộng",
    items: "món",
    tableNumber: "Số bàn",
    emailPlaceholder: "Email (tùy chọn)",
    close: "Đóng",
    cancel: "Hủy",
    continue: "Tiếp tục",
    recommended: "Bạn có thể thích"
  },
  ru: {
    premium: "Премиальный отдых на Фукуоке",
    all: "Все",
    appetizers: "Закуски",
    salads: "Салаты",
    soups: "Супы",
    pho: "Лапша Фо",
    seafood: "Морепродукты BBQ",
    main: "Основные блюда",
    fish: "Рыбные блюда",
    pasta: "Паста",
    curry: "Карри",
    beverages: "Напитки",
    dessert: "Десерт",
    smoothies: "Смузи",
    juice: "Свежий сок",
    cocktails: "Коктейли",
    beer: "Пиво",
    wine: "Вино",
    coffee: "Кофе",
    softDrinks: "Безалкогольные напитки",
    breakfast: "Завтрак",
    noodles: "Лапша",
    rice: "Рис",
    suggestions: "Варианты приготовления",
    addTray: "Добавить",
    empty: "Корзина пуста",
    home: "Меню",
    history: "История",
    chefNote: "Заметка шефу",
    notePlaceholder: "Аллергии или пожелания?",
    confirmOrder: "Подтвердить",
    orderNow: "ЗАКАЗАТЬ СЕЙЧАС",
    sent: "Отправлено!",
    successMsg: "Заказ принят.",
    backMenu: "В меню",
    noIce: "Без льда",
    lessIce: "Меньше льда",
    extraIce: "Больше льда",
    noSugar: "Без сахара",
    lessSugar: "Меньше сахара",
    extraSweet: "Более сладкий",
    roomTemp: "Комнатная температура",
    spicy: "Острый BBQ",
    garlic: "Лимонный чеснок",
    plain: "Обычный гриль",
    peel: "Очистить для меня",
    wellDone: "Хорошо прожаренный",
    rare: "С кровью",
    mediumRare: "Слабо прожаренный",
    medium: "Средний",
    trayTitle: "Ваша корзина",
    almostThere: "Почти готово!",
    tableSub: "Выберите номер стола",
    admin: "Админ",
    dashboard: "Панель",
    searchPlaceholder: "Поиск блюд...",
    selectLanguage: "Выберите язык",
    ingredients: "Ингредиенты",
    bestChoice: "Лучший выбор",
    total: "Итого",
    items: "позиций",
    tableNumber: "Номер стола",
    emailPlaceholder: "Email (необязательно)",
    close: "Закрыть",
    cancel: "Отмена",
    continue: "Продолжить",
    recommended: "Вам также может понравиться"
  },
  fr: {
    premium: "Restauration de luxe à Phu Quoc",
    all: "Tout",
    appetizers: "Entrées",
    salads: "Salades",
    soups: "Soupes",
    pho: "Nouilles Pho",
    seafood: "Fruits de Mer BBQ",
    main: "Plats Principaux",
    fish: "Plats de Poisson",
    pasta: "Pâtes",
    curry: "Curry",
    beverages: "Boissons",
    dessert: "Dessert",
    smoothies: "Smoothies",
    juice: "Jus Frais",
    cocktails: "Cocktails",
    beer: "Bière",
    wine: "Vin",
    coffee: "Café",
    softDrinks: "Boissons Gazeuses",
    breakfast: "Petit-déjeuner",
    noodles: "Nouilles",
    rice: "Riz",
    suggestions: "Suggestions de préparation",
    addTray: "Ajouter au Panier",
    empty: "Panier vide",
    home: "Accueil",
    history: "Historique",
    chefNote: "Note du Chef",
    notePlaceholder: "Des allergies ou des demandes spéciales ?",
    confirmOrder: "Confirmer",
    orderNow: "COMMANDER MAINTENANT",
    sent: "Envoyé !",
    successMsg: "Commande réussie.",
    backMenu: "Retour au menu",
    noIce: "Sans glace",
    lessIce: "Moins de glace",
    extraIce: "Plus de glace",
    noSugar: "Sans sucre",
    lessSugar: "Moins de sucre",
    extraSweet: "Plus sucré",
    roomTemp: "Température ambiante",
    spicy: "BBQ épicé",
    garlic: "Citron ail",
    plain: "Grillé nature",
    peel: "Décortiquer pour moi",
    wellDone: "Bien cuit",
    rare: "Saignant",
    mediumRare: "À point saignant",
    medium: "À point",
    trayTitle: "Votre Panier",
    almostThere: "Presque fini !",
    tableSub: "Sélectionnez votre numéro de table",
    admin: "Admin",
    dashboard: "Tableau de bord",
    searchPlaceholder: "Rechercher des plats...",
    selectLanguage: "Choisir la langue",
    ingredients: "Ingrédients",
    bestChoice: "Meilleur choix",
    total: "Total",
    items: "articles",
    tableNumber: "Numéro de table",
    emailPlaceholder: "Email (optionnel)",
    close: "Fermer",
    cancel: "Annuler",
    continue: "Continuer",
    recommended: "Vous aimerez peut-être aussi"
  },
  ja: {
    premium: "フーコック プレミアム ダイニング",
    all: "すべて",
    appetizers: "前菜",
    salads: "サラダ",
    soups: "スープ",
    pho: "フォー",
    seafood: "シーフードBBQ",
    main: "メイン料理",
    fish: "魚料理",
    pasta: "パスタ",
    curry: "カレー",
    beverages: "ドリンク",
    dessert: "デザート",
    smoothies: "スムージー",
    juice: "フレッシュジュース",
    cocktails: "カクテル",
    beer: "ビール",
    wine: "ワイン",
    coffee: "コーヒー",
    softDrinks: "ソフトドリンク",
    breakfast: "朝食",
    noodles: "麺類",
    rice: "ご飯類",
    suggestions: "調理オプション",
    addTray: "トレイに追加",
    empty: "トレイは空です",
    home: "ホーム",
    history: "履歴",
    chefNote: "シェフへのメモ",
    notePlaceholder: "アレルギーや特別なご要望は？",
    confirmOrder: "注文確定",
    orderNow: "今すぐ注文",
    sent: "送信完了！",
    successMsg: "ご注文を承りました。調理を開始します。",
    backMenu: "メニューに戻る",
    noIce: "氷なし",
    lessIce: "氷少なめ",
    extraIce: "氷多め",
    noSugar: "砂糖なし",
    lessSugar: "砂糖少なめ",
    extraSweet: "甘さ増し",
    roomTemp: "常温",
    spicy: "スパイシーBBQ",
    garlic: "レモンガーリック",
    plain: "プレーン",
    peel: "殻むき",
    wellDone: "よく焼き",
    rare: "レア",
    mediumRare: "ミディアムレア",
    medium: "ミディアム",
    trayTitle: "あなたのトレイ",
    almostThere: "あと少し！",
    tableSub: "テーブル番号を選択",
    admin: "管理者",
    dashboard: "ダッシュボード",
    searchPlaceholder: "料理を検索...",
    selectLanguage: "言語を選択",
    ingredients: "材料",
    bestChoice: "おすすめ",
    total: "合計",
    items: "品",
    tableNumber: "テーブル番号",
    emailPlaceholder: "メール（任意）",
    close: "閉じる",
    cancel: "キャンセル",
    continue: "続ける",
    recommended: "こちらもおすすめ"
  },
  ko: {
    premium: "푸꾸옥 프리미엄 다이닝",
    all: "전체",
    appetizers: "에피타이저",
    salads: "샐러드",
    soups: "수프",
    pho: "쌀국수",
    seafood: "해산물 BBQ",
    main: "메인 요리",
    fish: "생선 요리",
    pasta: "파스타",
    curry: "카레",
    beverages: "음료",
    dessert: "디저트",
    smoothies: "스무디",
    juice: "생과일주스",
    cocktails: "칵테일",
    beer: "맥주",
    wine: "와인",
    coffee: "커피",
    softDrinks: "음료수",
    breakfast: "아침식사",
    noodles: "면류",
    rice: "밥류",
    suggestions: "조리 옵션",
    addTray: "담기",
    empty: "트레이가 비어있습니다",
    home: "홈",
    history: "주문내역",
    chefNote: "셰프에게 메모",
    notePlaceholder: "알레르기나 특별 요청사항이 있으신가요?",
    confirmOrder: "주문 확인",
    orderNow: "지금 주문",
    sent: "전송 완료!",
    successMsg: "주문이 완료되었습니다. 조리를 시작합니다.",
    backMenu: "메뉴로 돌아가기",
    noIce: "얼음 없이",
    lessIce: "얼음 적게",
    extraIce: "얼음 많이",
    noSugar: "설탕 없이",
    lessSugar: "설탕 적게",
    extraSweet: "더 달게",
    roomTemp: "상온",
    spicy: "매운맛 BBQ",
    garlic: "레몬 갈릭",
    plain: "플레인",
    peel: "껍질 벗겨주세요",
    wellDone: "웰던",
    rare: "레어",
    mediumRare: "미디엄 레어",
    medium: "미디엄",
    trayTitle: "내 트레이",
    almostThere: "거의 다 됐어요!",
    tableSub: "테이블 번호를 선택하세요",
    admin: "관리자",
    dashboard: "대시보드",
    searchPlaceholder: "요리 검색...",
    selectLanguage: "언어 선택",
    ingredients: "재료",
    bestChoice: "추천",
    total: "총계",
    items: "개",
    tableNumber: "테이블 번호",
    emailPlaceholder: "이메일 (선택)",
    close: "닫기",
    cancel: "취소",
    continue: "계속",
    recommended: "이것도 좋아하실 거예요"
  },
  zh: {
    premium: "富国岛高级餐厅",
    all: "全部",
    appetizers: "开胃菜",
    salads: "沙拉",
    soups: "汤",
    pho: "越南河粉",
    seafood: "海鲜烧烤",
    main: "主菜",
    fish: "鱼类",
    pasta: "意大利面",
    curry: "咖喱",
    beverages: "饮品",
    dessert: "甜点",
    smoothies: "冰沙",
    juice: "鲜榨果汁",
    cocktails: "鸡尾酒",
    beer: "啤酒",
    wine: "葡萄酒",
    coffee: "咖啡",
    softDrinks: "软饮料",
    breakfast: "早餐",
    noodles: "面条",
    rice: "米饭",
    suggestions: "烹饪选项",
    addTray: "加入托盘",
    empty: "托盘为空",
    home: "首页",
    history: "历史",
    chefNote: "给厨师的备注",
    notePlaceholder: "有过敏或特殊要求吗？",
    confirmOrder: "确认订单",
    orderNow: "立即下单",
    sent: "已发送！",
    successMsg: "下单成功，厨房正在准备您的订单。",
    backMenu: "返回菜单",
    noIce: "去冰",
    lessIce: "少冰",
    extraIce: "加冰",
    noSugar: "无糖",
    lessSugar: "少糖",
    extraSweet: "加甜",
    roomTemp: "常温",
    spicy: "香辣烧烤",
    garlic: "柠檬蒜味",
    plain: "原味烤",
    peel: "帮我剥壳",
    wellDone: "全熟",
    rare: "一分熟",
    mediumRare: "三分熟",
    medium: "五分熟",
    trayTitle: "您的托盘",
    almostThere: "快完成了！",
    tableSub: "请选择您的桌号",
    admin: "管理员",
    dashboard: "仪表板",
    searchPlaceholder: "搜索菜品...",
    selectLanguage: "选择语言",
    ingredients: "配料",
    bestChoice: "推荐",
    total: "总计",
    items: "项",
    tableNumber: "桌号",
    emailPlaceholder: "邮箱（选填）",
    close: "关闭",
    cancel: "取消",
    continue: "继续",
    recommended: "您可能还喜欢"
  },
  de: {
    premium: "Phu Quoc Premium Gastronomie",
    all: "Alle",
    appetizers: "Vorspeisen",
    salads: "Salate",
    soups: "Suppen",
    pho: "Pho Nudeln",
    seafood: "Meeresfrüchte BBQ",
    main: "Hauptgerichte",
    fish: "Fischgerichte",
    pasta: "Pasta",
    curry: "Curry",
    beverages: "Getränke",
    dessert: "Dessert",
    smoothies: "Smoothies",
    juice: "Frischer Saft",
    cocktails: "Cocktails",
    beer: "Bier",
    wine: "Wein",
    coffee: "Kaffee",
    softDrinks: "Erfrischungsgetränke",
    breakfast: "Frühstück",
    noodles: "Nudeln",
    rice: "Reisgerichte",
    suggestions: "Zubereitungsoptionen",
    addTray: "Zum Tablett hinzufügen",
    empty: "Tablett ist leer",
    home: "Startseite",
    history: "Verlauf",
    chefNote: "Nachricht an den Koch",
    notePlaceholder: "Allergien oder besondere Wünsche?",
    confirmOrder: "Bestellung bestätigen",
    orderNow: "JETZT BESTELLEN",
    sent: "Gesendet!",
    successMsg: "Bestellung erfolgreich. Die Küche bereitet Ihre Bestellung vor.",
    backMenu: "Zurück zum Menü",
    noIce: "Ohne Eis",
    lessIce: "Weniger Eis",
    extraIce: "Extra Eis",
    noSugar: "Ohne Zucker",
    lessSugar: "Weniger Zucker",
    extraSweet: "Extra süß",
    roomTemp: "Zimmertemperatur",
    spicy: "Scharfes BBQ",
    garlic: "Zitronen-Knoblauch",
    plain: "Einfach gegrillt",
    peel: "Bitte schälen",
    wellDone: "Gut durch",
    rare: "Blutig",
    mediumRare: "Englisch",
    medium: "Medium",
    trayTitle: "Ihr Tablett",
    almostThere: "Fast fertig!",
    tableSub: "Wählen Sie Ihre Tischnummer",
    admin: "Admin",
    dashboard: "Dashboard",
    searchPlaceholder: "Gerichte suchen...",
    selectLanguage: "Sprache wählen",
    ingredients: "Zutaten",
    bestChoice: "Empfohlen",
    total: "Gesamt",
    items: "Artikel",
    tableNumber: "Tischnummer",
    emailPlaceholder: "E-Mail (optional)",
    close: "Schließen",
    cancel: "Abbrechen",
    continue: "Weiter",
    recommended: "Das könnte Ihnen auch gefallen"
  },
  es: {
    premium: "Gastronomía Premium Phu Quoc",
    all: "Todo",
    appetizers: "Entrantes",
    salads: "Ensaladas",
    soups: "Sopas",
    pho: "Fideos Pho",
    seafood: "Mariscos BBQ",
    main: "Platos Principales",
    fish: "Pescados",
    pasta: "Pasta",
    curry: "Curry",
    beverages: "Bebidas",
    dessert: "Postre",
    smoothies: "Batidos",
    juice: "Zumo Natural",
    cocktails: "Cócteles",
    beer: "Cerveza",
    wine: "Vino",
    coffee: "Café",
    softDrinks: "Refrescos",
    breakfast: "Desayuno",
    noodles: "Fideos",
    rice: "Arroz",
    suggestions: "Opciones de preparación",
    addTray: "Añadir a la bandeja",
    empty: "Bandeja vacía",
    home: "Inicio",
    history: "Historial",
    chefNote: "Nota para el chef",
    notePlaceholder: "¿Alergias o peticiones especiales?",
    confirmOrder: "Confirmar pedido",
    orderNow: "PEDIR AHORA",
    sent: "¡Enviado!",
    successMsg: "Pedido realizado. La cocina está preparando su pedido.",
    backMenu: "Volver al menú",
    noIce: "Sin hielo",
    lessIce: "Menos hielo",
    extraIce: "Extra hielo",
    noSugar: "Sin azúcar",
    lessSugar: "Menos azúcar",
    extraSweet: "Extra dulce",
    roomTemp: "Temperatura ambiente",
    spicy: "BBQ picante",
    garlic: "Limón y ajo",
    plain: "A la plancha",
    peel: "Pelar por favor",
    wellDone: "Muy hecho",
    rare: "Poco hecho",
    mediumRare: "Poco hecho",
    medium: "Al punto",
    trayTitle: "Tu bandeja",
    almostThere: "¡Ya casi!",
    tableSub: "Selecciona tu número de mesa",
    admin: "Admin",
    dashboard: "Panel",
    searchPlaceholder: "Buscar platos...",
    selectLanguage: "Seleccionar idioma",
    ingredients: "Ingredientes",
    bestChoice: "Recomendado",
    total: "Total",
    items: "artículos",
    tableNumber: "Número de mesa",
    emailPlaceholder: "Email (opcional)",
    close: "Cerrar",
    cancel: "Cancelar",
    continue: "Continuar",
    recommended: "También te puede gustar"
  },
  th: {
    premium: "ภูเก็ต พรีเมียม ไดนิ่ง",
    all: "ทั้งหมด",
    appetizers: "อาหารเรียกน้ำย่อย",
    salads: "สลัด",
    soups: "ซุป",
    pho: "ก๋วยเตี๋ยวเวียดนาม",
    seafood: "อาหารทะเล BBQ",
    main: "อาหารจานหลัก",
    fish: "อาหารปลา",
    pasta: "พาสต้า",
    curry: "แกงกะหรี่",
    beverages: "เครื่องดื่ม",
    dessert: "ของหวาน",
    smoothies: "สมูทตี้",
    juice: "น้ำผลไม้สด",
    cocktails: "ค็อกเทล",
    beer: "เบียร์",
    wine: "ไวน์",
    coffee: "กาแฟ",
    softDrinks: "น้ำอัดลม",
    breakfast: "อาหารเช้า",
    noodles: "เส้น",
    rice: "ข้าว",
    suggestions: "ตัวเลือกการปรุง",
    addTray: "เพิ่มลงถาด",
    empty: "ถาดว่างเปล่า",
    home: "หน้าแรก",
    history: "ประวัติ",
    chefNote: "หมายเหตุถึงเชฟ",
    notePlaceholder: "แพ้อาหารหรือคำขอพิเศษ?",
    confirmOrder: "ยืนยันคำสั่งซื้อ",
    orderNow: "สั่งเลย",
    sent: "ส่งแล้ว!",
    successMsg: "สั่งอาหารสำเร็จ ครัวกำลังเตรียมอาหาร",
    backMenu: "กลับสู่เมนู",
    noIce: "ไม่ใส่น้ำแข็ง",
    lessIce: "น้ำแข็งน้อย",
    extraIce: "น้ำแข็งเยอะ",
    noSugar: "ไม่ใส่น้ำตาล",
    lessSugar: "หวานน้อย",
    extraSweet: "หวานมาก",
    roomTemp: "อุณหภูมิห้อง",
    spicy: "BBQ เผ็ด",
    garlic: "มะนาวกระเทียม",
    plain: "ย่างธรรมดา",
    peel: "ปอกเปลือกให้",
    wellDone: "สุกมาก",
    rare: "สุกน้อย",
    mediumRare: "สุกน้อยปานกลาง",
    medium: "สุกปานกลาง",
    trayTitle: "ถาดของคุณ",
    almostThere: "เกือบเสร็จแล้ว!",
    tableSub: "เลือกหมายเลขโต๊ะ",
    admin: "ผู้ดูแล",
    dashboard: "แดชบอร์ด",
    searchPlaceholder: "ค้นหาอาหาร...",
    selectLanguage: "เลือกภาษา",
    ingredients: "ส่วนผสม",
    bestChoice: "แนะนำ",
    total: "รวม",
    items: "รายการ",
    tableNumber: "หมายเลขโต๊ะ",
    emailPlaceholder: "อีเมล (ไม่บังคับ)",
    close: "ปิด",
    cancel: "ยกเลิก",
    continue: "ดำเนินการต่อ",
    recommended: "คุณอาจชอบ"
  },
  it: {
    premium: "Phu Quoc Ristorazione Premium",
    all: "Tutto",
    appetizers: "Antipasti",
    salads: "Insalate",
    soups: "Zuppe",
    pho: "Noodles Pho",
    seafood: "Frutti di Mare BBQ",
    main: "Piatti Principali",
    fish: "Piatti di Pesce",
    pasta: "Pasta",
    curry: "Curry",
    beverages: "Bevande",
    dessert: "Dolce",
    smoothies: "Frullati",
    juice: "Succo Fresco",
    cocktails: "Cocktail",
    beer: "Birra",
    wine: "Vino",
    coffee: "Caffè",
    softDrinks: "Bibite",
    breakfast: "Colazione",
    noodles: "Noodles",
    rice: "Riso",
    suggestions: "Opzioni di preparazione",
    addTray: "Aggiungi al vassoio",
    empty: "Vassoio vuoto",
    home: "Home",
    history: "Cronologia",
    chefNote: "Nota per lo chef",
    notePlaceholder: "Allergie o richieste speciali?",
    confirmOrder: "Conferma ordine",
    orderNow: "ORDINA ORA",
    sent: "Inviato!",
    successMsg: "Ordine effettuato. La cucina sta preparando il tuo ordine.",
    backMenu: "Torna al menu",
    noIce: "Senza ghiaccio",
    lessIce: "Poco ghiaccio",
    extraIce: "Ghiaccio extra",
    noSugar: "Senza zucchero",
    lessSugar: "Poco zucchero",
    extraSweet: "Extra dolce",
    roomTemp: "Temperatura ambiente",
    spicy: "BBQ piccante",
    garlic: "Limone e aglio",
    plain: "Grigliato semplice",
    peel: "Sbucciare per favore",
    wellDone: "Ben cotto",
    rare: "Al sangue",
    mediumRare: "Poco cotto",
    medium: "Cottura media",
    trayTitle: "Il tuo vassoio",
    almostThere: "Quasi fatto!",
    tableSub: "Seleziona il numero del tavolo",
    admin: "Admin",
    dashboard: "Dashboard",
    searchPlaceholder: "Cerca piatti...",
    selectLanguage: "Seleziona lingua",
    ingredients: "Ingredienti",
    bestChoice: "Consigliato",
    total: "Totale",
    items: "articoli",
    tableNumber: "Numero tavolo",
    emailPlaceholder: "Email (opzionale)",
    close: "Chiudi",
    cancel: "Annulla",
    continue: "Continua",
    recommended: "Potrebbe piacerti anche"
  },
  pt: {
    premium: "Phu Quoc Gastronomia Premium",
    all: "Todos",
    appetizers: "Entradas",
    salads: "Saladas",
    soups: "Sopas",
    pho: "Macarrão Pho",
    seafood: "Frutos do Mar BBQ",
    main: "Pratos Principais",
    fish: "Pratos de Peixe",
    pasta: "Massa",
    curry: "Curry",
    beverages: "Bebidas",
    dessert: "Sobremesa",
    smoothies: "Smoothies",
    juice: "Suco Natural",
    cocktails: "Coquetéis",
    beer: "Cerveja",
    wine: "Vinho",
    coffee: "Café",
    softDrinks: "Refrigerantes",
    breakfast: "Café da manhã",
    noodles: "Macarrão",
    rice: "Arroz",
    suggestions: "Opções de preparo",
    addTray: "Adicionar à bandeja",
    empty: "Bandeja vazia",
    home: "Início",
    history: "Histórico",
    chefNote: "Nota para o chef",
    notePlaceholder: "Alergias ou pedidos especiais?",
    confirmOrder: "Confirmar pedido",
    orderNow: "PEDIR AGORA",
    sent: "Enviado!",
    successMsg: "Pedido realizado. A cozinha está preparando seu pedido.",
    backMenu: "Voltar ao menu",
    noIce: "Sem gelo",
    lessIce: "Pouco gelo",
    extraIce: "Gelo extra",
    noSugar: "Sem açúcar",
    lessSugar: "Pouco açúcar",
    extraSweet: "Extra doce",
    roomTemp: "Temperatura ambiente",
    spicy: "BBQ picante",
    garlic: "Limão e alho",
    plain: "Grelhado simples",
    peel: "Descascar por favor",
    wellDone: "Bem passado",
    rare: "Mal passado",
    mediumRare: "Ao ponto para mal",
    medium: "Ao ponto",
    trayTitle: "Sua bandeja",
    almostThere: "Quase lá!",
    tableSub: "Selecione o número da mesa",
    admin: "Admin",
    dashboard: "Painel",
    searchPlaceholder: "Buscar pratos...",
    selectLanguage: "Selecionar idioma",
    ingredients: "Ingredientes",
    bestChoice: "Recomendado",
    total: "Total",
    items: "itens",
    tableNumber: "Número da mesa",
    emailPlaceholder: "Email (opcional)",
    close: "Fechar",
    cancel: "Cancelar",
    continue: "Continuar",
    recommended: "Você também pode gostar"
  },
  nl: {
    premium: "Phu Quoc Premium Dining",
    all: "Alles",
    appetizers: "Voorgerechten",
    salads: "Salades",
    soups: "Soepen",
    pho: "Pho Noedels",
    seafood: "Zeevruchten BBQ",
    main: "Hoofdgerechten",
    fish: "Visgerechten",
    pasta: "Pasta",
    curry: "Curry",
    beverages: "Dranken",
    dessert: "Dessert",
    smoothies: "Smoothies",
    juice: "Vers Sap",
    cocktails: "Cocktails",
    beer: "Bier",
    wine: "Wijn",
    coffee: "Koffie",
    softDrinks: "Frisdranken",
    breakfast: "Ontbijt",
    noodles: "Noedels",
    rice: "Rijstgerechten",
    suggestions: "Bereidingsopties",
    addTray: "Toevoegen aan dienblad",
    empty: "Dienblad is leeg",
    home: "Home",
    history: "Geschiedenis",
    chefNote: "Notitie voor de chef",
    notePlaceholder: "Allergieën of speciale verzoeken?",
    confirmOrder: "Bestelling bevestigen",
    orderNow: "NU BESTELLEN",
    sent: "Verzonden!",
    successMsg: "Bestelling geplaatst. De keuken bereidt uw bestelling voor.",
    backMenu: "Terug naar menu",
    noIce: "Zonder ijs",
    lessIce: "Minder ijs",
    extraIce: "Extra ijs",
    noSugar: "Zonder suiker",
    lessSugar: "Minder suiker",
    extraSweet: "Extra zoet",
    roomTemp: "Kamertemperatuur",
    spicy: "Pittige BBQ",
    garlic: "Citroen knoflook",
    plain: "Gewoon gegrild",
    peel: "Schillen alstublieft",
    wellDone: "Doorbakken",
    rare: "Rood",
    mediumRare: "Half rood",
    medium: "Medium",
    trayTitle: "Uw dienblad",
    almostThere: "Bijna klaar!",
    tableSub: "Selecteer uw tafelnummer",
    admin: "Admin",
    dashboard: "Dashboard",
    searchPlaceholder: "Gerechten zoeken...",
    selectLanguage: "Taal selecteren",
    ingredients: "Ingrediënten",
    bestChoice: "Aanbevolen",
    total: "Totaal",
    items: "items",
    tableNumber: "Tafelnummer",
    emailPlaceholder: "E-mail (optioneel)",
    close: "Sluiten",
    cancel: "Annuleren",
    continue: "Doorgaan",
    recommended: "Dit vind je misschien ook leuk"
  },
  id: {
    premium: "Phu Quoc Premium Dining",
    all: "Semua",
    appetizers: "Makanan Pembuka",
    salads: "Salad",
    soups: "Sup",
    pho: "Mie Pho",
    seafood: "Seafood BBQ",
    main: "Hidangan Utama",
    fish: "Hidangan Ikan",
    pasta: "Pasta",
    curry: "Kari",
    beverages: "Minuman",
    dessert: "Hidangan Penutup",
    smoothies: "Smoothie",
    juice: "Jus Segar",
    cocktails: "Koktail",
    beer: "Bir",
    wine: "Anggur",
    coffee: "Kopi",
    softDrinks: "Minuman Ringan",
    breakfast: "Sarapan",
    noodles: "Mie",
    rice: "Nasi",
    suggestions: "Opsi Penyajian",
    addTray: "Tambah ke nampan",
    empty: "Nampan kosong",
    home: "Beranda",
    history: "Riwayat",
    chefNote: "Catatan untuk koki",
    notePlaceholder: "Alergi atau permintaan khusus?",
    confirmOrder: "Konfirmasi pesanan",
    orderNow: "PESAN SEKARANG",
    sent: "Terkirim!",
    successMsg: "Pesanan berhasil. Dapur sedang menyiapkan pesanan Anda.",
    backMenu: "Kembali ke menu",
    noIce: "Tanpa es",
    lessIce: "Es sedikit",
    extraIce: "Es ekstra",
    noSugar: "Tanpa gula",
    lessSugar: "Gula sedikit",
    extraSweet: "Ekstra manis",
    roomTemp: "Suhu ruangan",
    spicy: "BBQ pedas",
    garlic: "Lemon bawang putih",
    plain: "Panggang biasa",
    peel: "Kupas untuk saya",
    wellDone: "Matang sempurna",
    rare: "Setengah matang",
    mediumRare: "Agak matang",
    medium: "Matang sedang",
    trayTitle: "Nampan Anda",
    almostThere: "Hampir selesai!",
    tableSub: "Pilih nomor meja",
    admin: "Admin",
    dashboard: "Dasbor",
    searchPlaceholder: "Cari hidangan...",
    selectLanguage: "Pilih bahasa",
    ingredients: "Bahan",
    bestChoice: "Pilihan Terbaik",
    total: "Total",
    items: "item",
    tableNumber: "Nomor meja",
    emailPlaceholder: "Email (opsional)",
    close: "Tutup",
    cancel: "Batal",
    continue: "Lanjutkan",
    recommended: "Anda mungkin juga suka"
  },
  ar: {
    premium: "فو كوك للمطاعم الفاخرة",
    all: "الكل",
    appetizers: "المقبلات",
    salads: "السلطات",
    soups: "الشوربات",
    pho: "نودلز فو",
    seafood: "المأكولات البحرية المشوية",
    main: "الأطباق الرئيسية",
    fish: "أطباق السمك",
    pasta: "المعكرونة",
    curry: "الكاري",
    beverages: "المشروبات",
    dessert: "الحلويات",
    smoothies: "سموذي",
    juice: "عصير طازج",
    cocktails: "كوكتيل",
    beer: "بيرة",
    wine: "نبيذ",
    coffee: "قهوة",
    softDrinks: "مشروبات غازية",
    breakfast: "فطور",
    noodles: "نودلز",
    rice: "أرز",
    suggestions: "خيارات التحضير",
    addTray: "أضف إلى الصينية",
    empty: "الصينية فارغة",
    home: "الرئيسية",
    history: "السجل",
    chefNote: "ملاحظة للشيف",
    notePlaceholder: "حساسية أو طلبات خاصة؟",
    confirmOrder: "تأكيد الطلب",
    orderNow: "اطلب الآن",
    sent: "تم الإرسال!",
    successMsg: "تم الطلب بنجاح. المطبخ يحضر طلبك.",
    backMenu: "العودة للقائمة",
    noIce: "بدون ثلج",
    lessIce: "ثلج أقل",
    extraIce: "ثلج إضافي",
    noSugar: "بدون سكر",
    lessSugar: "سكر أقل",
    extraSweet: "حلو إضافي",
    roomTemp: "درجة حرارة الغرفة",
    spicy: "باربكيو حار",
    garlic: "ليمون وثوم",
    plain: "مشوي عادي",
    peel: "قشر لي من فضلك",
    wellDone: "ناضج جيداً",
    rare: "نصف نضج",
    mediumRare: "نضج متوسط خفيف",
    medium: "نضج متوسط",
    trayTitle: "صينيتك",
    almostThere: "تقريباً انتهيت!",
    tableSub: "اختر رقم الطاولة",
    admin: "المسؤول",
    dashboard: "لوحة التحكم",
    searchPlaceholder: "ابحث عن الأطباق...",
    selectLanguage: "اختر اللغة",
    ingredients: "المكونات",
    bestChoice: "الاختيار الأفضل",
    total: "المجموع",
    items: "عناصر",
    tableNumber: "رقم الطاولة",
    emailPlaceholder: "البريد الإلكتروني (اختياري)",
    close: "إغلاق",
    cancel: "إلغاء",
    continue: "متابعة",
    recommended: "قد يعجبك أيضاً"
  },
  hi: {
    premium: "फू क्वोक प्रीमियम डाइनिंग",
    all: "सभी",
    appetizers: "स्टार्टर",
    salads: "सलाद",
    soups: "सूप",
    pho: "फो नूडल्स",
    seafood: "सीफूड बीबीक्यू",
    main: "मुख्य व्यंजन",
    fish: "मछली व्यंजन",
    pasta: "पास्ता",
    curry: "करी",
    beverages: "पेय पदार्थ",
    dessert: "मिठाई",
    smoothies: "स्मूदी",
    juice: "ताज़ा जूस",
    cocktails: "कॉकटेल",
    beer: "बीयर",
    wine: "वाइन",
    coffee: "कॉफी",
    softDrinks: "सॉफ्ट ड्रिंक्स",
    breakfast: "नाश्ता",
    noodles: "नूडल्स",
    rice: "चावल",
    suggestions: "तैयारी के विकल्प",
    addTray: "ट्रे में जोड़ें",
    empty: "ट्रे खाली है",
    home: "होम",
    history: "इतिहास",
    chefNote: "शेफ के लिए नोट",
    notePlaceholder: "एलर्जी या विशेष अनुरोध?",
    confirmOrder: "ऑर्डर की पुष्टि करें",
    orderNow: "अभी ऑर्डर करें",
    sent: "भेज दिया!",
    successMsg: "ऑर्डर सफल। रसोई आपका ऑर्डर तैयार कर रही है।",
    backMenu: "मेन्यू पर वापस जाएं",
    noIce: "बिना बर्फ",
    lessIce: "कम बर्फ",
    extraIce: "अतिरिक्त बर्फ",
    noSugar: "बिना चीनी",
    lessSugar: "कम चीनी",
    extraSweet: "अतिरिक्त मीठा",
    roomTemp: "कमरे का तापमान",
    spicy: "मसालेदार बीबीक्यू",
    garlic: "नींबू लहसुन",
    plain: "साधारण ग्रिल्ड",
    peel: "छिलका उतार दें",
    wellDone: "अच्छी तरह पकाएं",
    rare: "कच्चा",
    mediumRare: "हल्का पका",
    medium: "मध्यम पका",
    trayTitle: "आपकी ट्रे",
    almostThere: "लगभग हो गया!",
    tableSub: "अपना टेबल नंबर चुनें",
    admin: "एडमिन",
    dashboard: "डैशबोर्ड",
    searchPlaceholder: "व्यंजन खोजें...",
    selectLanguage: "भाषा चुनें",
    ingredients: "सामग्री",
    bestChoice: "सर्वश्रेष्ठ विकल्प",
    total: "कुल",
    items: "आइटम",
    tableNumber: "टेबल नंबर",
    emailPlaceholder: "ईमेल (वैकल्पिक)",
    close: "बंद करें",
    cancel: "रद्द करें",
    continue: "जारी रखें",
    recommended: "आपको यह भी पसंद आ सकता है"
  }
};

export const categoryOptions = {
  "Beverages": ["noIce", "lessIce", "noSugar", "lessSugar", "roomTemp"],
  "Seafood": ["spicy", "garlic", "plain", "peel", "wellDone"],
  "Pasta": ["Extra Cheese", "No Garlic", "Spicy"],
  "Appetizers": ["Extra Sauce", "Crispy", "No Onions"],
  "Main": ["Less Spicy", "No Garnish", "Hotter"],
  "Pho": ["No Cilantro", "Extra Sprouts", "More Broth"]
};

export const formatPrice = (p) => {
  return (p * 1000).toLocaleString('en-US') + " VND";
};
